module.exports = __webpack_public_path__ + "static/media/logo.23e9a0e9.png";